import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  CustomInput,
  Input,
  FormGroup,
  Form,
  Label,
  Button,
  Col,
  Row
} from "reactstrap";
import Icons from "../../atoms/icons";
import useCustomReducer from "../../../hooks/useCustomReducer";
import InputData from "../../atoms/input-data";
import T from "../../atoms/translate";

function AttributeCard({
  formTitle,
  resultsTitle,
  attributes,
  addAttribute,
  deleteAttribute,
  updateAttribute,
  columns,
  inputData = null
}) {
  const [activeIndex, setActiveIndex] = useState(null);
  const updateIndex = (index, data) => {
    setForm(data);
    setActiveIndex(index);
  };
  const changeInputContext = input => {
    if (inputData != null) {
      const tmp = Object.entries(input.inputData).map(([key, o]) => ({
        name: key,
        ...o
      }))[0];
      setForm(tmp);
    }
  };
  const changeForm = e => {
    const { target } = e;
    if (target.type === "select") {
      const values = [].filter
        .call(target.options, o => o.selected)
        .map(o => o.value);
      setForm({ [target.name]: values });
    } else {
      setForm({
        [target.name]:
          target.type === "checkbox" ? target.checked : target.value
      });
    }
  };
  const [form, setForm] = useCustomReducer({});
  const visibleInput = input => {
    if (input.visible && input.dependence) {
      const tmp = form[input.dependence];
      if (tmp) {
        return input.visible[tmp];
      }
      return true;
    }
    return true;
  };
  useEffect(() => {
    if (columns)
      setForm({
        ...Object.fromEntries(
          columns
            .filter(o => (o.index ? !o.index : true))
            .map(o => [o.key, o.type === "switch" ? false : ""])
        )
      });
    setActiveIndex(null);
  }, [columns, setForm]);
  return (
    <>
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              {formTitle}
            </h1>
          </Col>
          <Col xs="12">
            <Form
              onSubmit={e => {
                e.preventDefault();
                if (activeIndex !== null) {
                  updateAttribute(form, activeIndex);
                } else {
                  addAttribute(form);
                }
              }}
            >
              <Row form>
                {columns.map((o, index) => {
                  if (o.index !== true && visibleInput(o))
                    return (
                      <Col key={index} md={o.cols || 2}>
                        <FormGroup>
                          <Label for={o.key}>
                            {o.label} {o.tooltip || null}
                          </Label>
                          {o.type === "switch" || o.type === "select" ? (
                            <CustomInput
                              bsSize="sm"
                              required={o.required ? o.required : false}
                              type={o.type}
                              name={o.key}
                              disabled={o.disable === true}
                              checked={form[o.key] || false}
                              value={form[o.key] || ""}
                              onChange={changeForm}
                              id={o.key}
                            >
                              {o.options && o.type === "select" ? (
                                <>
                                  <option value="" />
                                  {o.dependence
                                    ? Object.entries(
                                        form[o.dependence]
                                          ? o.options[form[o.dependence]]
                                          : {}
                                      ).map(([key, id], i) => (
                                        <option key={i} value={id}>
                                          {key}
                                        </option>
                                      ))
                                    : Object.entries(o.options).map(
                                        ([key, id], i) => (
                                          <option key={i} value={id}>
                                            {key}
                                          </option>
                                        )
                                      )}
                                </>
                              ) : (
                                ""
                              )}
                            </CustomInput>
                          ) : o.type === "context" ? (
                            <InputData
                              inputSize="sm"
                              context={o.context}
                              changeInput={changeInputContext}
                              isReturn={true}
                            >
                              <Input
                                type="text"
                                name={o.key}
                                id={o.key}
                                required={o.required ? o.required : false}
                                value={form[o.key] || ""}
                                onChange={changeForm}
                                disabled={o.disable === true}
                                bsSize="sm"
                              />
                            </InputData>
                          ) : (
                            <Input
                              type={o.type}
                              name={o.key}
                              id={o.key}
                              required={o.required ? o.required : false}
                              value={form[o.key] || ""}
                              onChange={changeForm}
                              bsSize="sm"
                              placeholder={o.name}
                              disabled={o.disable === true}
                            />
                          )}
                        </FormGroup>
                      </Col>
                    );
                  return "";
                })}
                <Col sm="3" style={{ marginTop: "28px" }}>
                  {activeIndex != null ? (
                    <Button block size="sm" color="success" type="submit">
                      <T i18nKey="actualizar" />
                    </Button>
                  ) : (
                    <Button block size="sm" color="primary" type="submit">
                      <T i18nKey="crear" />
                    </Button>
                  )}
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              {resultsTitle}
            </h1>
          </Col>
          <Col xs="12">
            <Card body className="p-0">
              <Table bordered className="mb-0">
                <thead>
                  <tr>
                    {columns.map((o, index) => {
                      if (o.columnVisible == null || o.columnVisible)
                        return <th key={index}>{o.label}</th>;
                      return null;
                    })}
                    <th>
                      <T i18nKey="editar" />
                    </th>
                    <th>
                      <T i18nKey="borrar" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {attributes.map((a, index) => {
                    return (
                      <tr key={index}>
                        {columns.map((o, i) => {
                          if (o.columnVisible == null || o.columnVisible)
                            return (
                              <td key={i}>
                                {a[o.key] ? a[o.key].toString() : ""}
                              </td>
                            );
                          return null;
                        })}
                        <td>
                          <Button
                            size="sm"
                            color="primary"
                            disabled={a.primaryKey || a.foreignKey}
                            onClick={() => updateIndex(index, a)}
                          >
                            <Icons
                              Config={{ size: "1.2em", color: "white" }}
                              Icon="MdCreate"
                            />
                          </Button>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            color="danger"
                            disabled={a.primaryKey || a.foreignKey}
                            onClick={() => deleteAttribute(index)}
                          >
                            <Icons
                              Config={{ size: "1.2em", color: "white" }}
                              Icon="MdDelete"
                            />
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Card>
    </>
  );
}

AttributeCard.defaultProps = {
  formTitle: "Agregar datos",
  resultsTitle: "Listado"
};

export default AttributeCard;
